import { render, staticRenderFns } from "./activity_details.vue?vue&type=template&id=07645792&scoped=true&"
import script from "./activity_details.vue?vue&type=script&lang=js&"
export * from "./activity_details.vue?vue&type=script&lang=js&"
import style0 from "./activity_details.vue?vue&type=style&index=0&id=07645792&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07645792",
  null
  
)

export default component.exports